/**
 * Module-level cache: userId string → { label, image? }.
 *
 * Populated by `useInterviewerField.loadOptions` whenever the async
 * select fetches interviewers.  Read by `useEditConfirmation.requestSave`
 * so newly searched+selected interviewers (whose metadata is NOT in the
 * initial `participant_default_options`) still appear in the confirmation
 * dialog with correct name/avatar.
 */

interface CachedOption {
  label: string;
  image?: string;
}

const cache = new Map<string, CachedOption>();

export function cacheInterviewerOptions(
  options: Array<{ value: string; label: string; image?: string }>
): void {
  for (const o of options) {
    if (o.value) cache.set(o.value, { label: o.label, image: o.image });
  }
}

export function getCachedInterviewerOption(
  id: string
): CachedOption | undefined {
  return cache.get(id);
}
